import {Maybe} from 'graphql/jsutils/Maybe';
import {SCHEME_CLOSE_WEBVIEW, SCHEME_OPEN_APP_STORE} from '../common/constant';
import {t} from '../common/getTranslations';
import {requestContext} from '../common/requestContext';
import {ApiStatusCodeVo as BillingApiStatusCodeVo} from '../common/shared/api/billing/enums/ApiStatusCodeVo.enum';
import {ApiStatusCodeVo} from '../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {
  ButtonV2Size,
  ButtonV2Variant,
} from '../design-system/atoms/ButtonV2/ButtonV2.enum';
import {Dialog} from '../design-system/organisms/Dialog';
import {removeSimpleDialog, showStandaloneDialog} from './simpleDialogHandler';

export function getIsLegacyVersionUpdateError(
  resultCode?: number | Maybe<number>
): boolean {
  return (
    requestContext.requestInfo.display.isWebView &&
    (resultCode === ApiStatusCodeVo.NeedUpdate ||
      resultCode === BillingApiStatusCodeVo.NeedUpdate)
  );
}

export function showLegacyVersionUpdateDialog(closeWebView = true) {
  showStandaloneDialog({
    dialogComponent: (
      <Dialog
        isOpen={true}
        isMobile={true}
        onClose={removeSimpleDialog}
        shouldCloseOnDimmedClick={false}
      >
        <Dialog.Dimmed />
        <Dialog.Title>{t('version_update_popup_title')}</Dialog.Title>
        <Dialog.List className="items-center">
          <Dialog.Button
            onClick={() => window.location.assign(SCHEME_OPEN_APP_STORE)}
            size={ButtonV2Size.Medium}
            variant={ButtonV2Variant.Primary}
          >
            {t('version_update_popup_detail')}
          </Dialog.Button>
        </Dialog.List>
        <Dialog.BottomCombination>
          <Dialog.Button
            variant={ButtonV2Variant.Secondary}
            onClick={() => {
              if (closeWebView) {
                window.location.assign(SCHEME_CLOSE_WEBVIEW);
                return;
              }

              removeSimpleDialog();
            }}
          >
            {t('common_close_button')}
          </Dialog.Button>
        </Dialog.BottomCombination>
      </Dialog>
    ),
  });
}
